import React from 'react';
import { t } from '../../../utilities/translator';

export default function Nights(props) {
  const { nights, changeNights, daysInterval } = props;
  const name = t('secondaryFilter.nights');

  return (
    <div className="filter-item">
      <p className="filter-item__name">
        <span>{name}</span>
      </p>
      <div className="filter-body">
        <div className="filter-nights__wrap">
          <div className="filter-nights__list">
            {nights.map(({ value, isSelected }) => (
              <div
                key={value}
                className={`filter-nights__item ${isSelected && 'filter-nights__item--selected'} ${
                  daysInterval && daysInterval < value ? 'not-active-night' : ''
                }`}
                onClick={changeNights(value)}
              >
                {value}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
